import { useMutation } from '@tanstack/react-query';

import type { LensState } from '~/pages/LeLens/document/types';

import { reportingLeLensPdfPath } from '~/consts/reportingLeLensApi';

import { request } from '~/services/common';

import { resolveReportingLeLensUrl } from '~/utils/resolveReportingLeLensUrl';

export function useExportLensPdf(lensId: string) {
  return useMutation({
    mutationFn: async ({ state, title, lensVersion }: { state: LensState; title: string; lensVersion?: number }) => {
      const file = (await request(resolveReportingLeLensUrl(reportingLeLensPdfPath(lensId)), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ state, lensVersion }),
        download: true,
      })) as Blob;
      const link = document.createElement('a');
      link.href = URL.createObjectURL(file);
      link.download = `${title}.pdf`;
      link.click();
      window.setTimeout(() => URL.revokeObjectURL(link.href), 1000);
    },
  });
}
